import EntryGroupsSplit from "@/components/EntryGroupsSplit";
import type { JourneyAcquisitionChannels } from "@/lib/api";

type Props = {
  channels?: JourneyAcquisitionChannels;
  title?: string;
  subtitle?: string;
  showModeToggle?: boolean;
};

/** Wspólny pasek płatne vs pozostałe dla zakładek journey (wizyty na stronie). */
export default function JourneyEntryGroupsSplit({
  channels,
  title = "Wejścia: płatne vs pozostałe",
  subtitle = "?via=ad lub Social płatny · reszta = organiczne, direct, wyszukiwarka itd.",
  showModeToggle = true,
}: Props) {
  return (
    <EntryGroupsSplit
      paid={channels?.entry_groups?.paid}
      other={channels?.entry_groups?.other}
      title={title}
      subtitle={subtitle}
      showModeToggle={showModeToggle}
      defaultMode="all"
    />
  );
}
